module.exports = __webpack_public_path__ + "assets/img/xander_venter.82e39aa9.png";